import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/services/auth.service';

import * as moment from 'moment';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'ngx-reset-password-request',
  templateUrl: './reset-password-request.component.html',
  styleUrls: ['./reset-password-request.component.scss']
})
export class ResetPasswordRequestComponent implements OnInit {

 
  loginForm: FormGroup;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;



  invalidMessage =null;
  isInvalidData = false;
  errorMessage = '';
  roles: string[] = [];

  validationMessages = {
    'email': { 'required': 'Email is required','email': 'Email must be a valid email address' },
    'username': { 'required': 'Username is required' },
  };

  formErrors = {
    'email': "",
    'username': "",
  };

  constructor (
    private fb: FormBuilder,
    private router : Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private userService : UserService,
    ) { }

  ngOnInit() {

    this.loginForm = this.fb.group({
      email : ['', [Validators.required, Validators.email]],
      username : ['', Validators.required],  
      requestDate : [moment().format('MM/DD/YYYY h:mm:ss A'), Validators.required],      
    });

    this.loginForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.loginForm);
    });

  }

  onSubmit() {
    var getFormData : any;
    getFormData = this.loginForm.value;
    this.showProcessingIndicator = true; 
        this.userService.resetPasswordRequest(getFormData).subscribe(
        (res) => {

          if(res.success===0){
            this.toastr.error('Entered username is invalid','Warning');
            this.showProcessingIndicator = false; 

          }else{
            this.toastr.success('Password reset request sent successfully','Success');
            this.showProcessingIndicator = false; 
            this.loginForm.reset();  
          }
                                                           

          },        
        (err) =>  {
            this.toastr.error('Failed to send reset password request');                            
            this.showProcessingIndicator = false;
            console.log(err);
          }, 
        )
  }



   logValidationErrors(group: FormGroup = this.loginForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      this.invalidMessage = null;
      if(isDirty)
      {
        this.loginForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


} // end class
